import http from '@root/utils/axios/admin';

let state = {
    StoresList: [],
    Store: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchStoresList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/stores', { params: filter }).then((response) => {
                commit('setStores', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteStore({ commit }, id) {
        return http.delete('/api/stores/' + id);
    },

    fetchStore({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/stores/' + id).then((response) => {
                commit('setStore', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateStore({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/stores', data).then((response) => {
                commit('setStore', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setStoreError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateStore({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/stores/' + data.get('id'), data).then((response) => {
                commit('setStore', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setStoreError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setStores(state, data) {
        state.StoresList = data;
    },
    setStore(state, data) {
        state.Store.data = data;
    },
    setStoreError(state, error) {

        state.Store.error = error.errors;
    },
    cleanStoreError(state, error) {
        state.Store.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}